import React, { useEffect, useState, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import { Col, Row, Badge } from 'react-bootstrap';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { FiEdit2, FiEye } from 'react-icons/fi';
import * as _ from 'lodash';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { getTermsAndConditions } from 'api/termsAndCondition';
import { formatOfferDate } from 'view/sessionLevelOffer/SessionLevelOfferList';

const TermsAndConditionList = () => {
  const { navigateTo } = useContext(NavContext);
  const [tncs, setTncs] = useState(null);

  useEffect(() => {
    getTermsAndConditions()
      .then((res) => setTncs(res.data))
      .catch(() => setTncs([]));
  }, []);

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title="App Terms & Conditions" />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="user-group-page_main">
              <div className="user-group-main-block">
                <Card>
                  <div className="user-group-block">
                    <div className="user-group-search-box">
                      <Row className="align-items-center">
                        <Col className="d-flex justify-content-end">
                          <Button className="user-group-btn" onClick={() => navigateTo('/addTermsAndCondition')}>
                            Add Version
                          </Button>
                        </Col>
                      </Row>
                    </div>
                    <div className="user-group-table">
                      <div className="table-responsive">
                        <table className="record-list-table">
                          <thead>
                            <tr>
                              <th className="px-3">Version</th>
                              <th className="px-3">Link</th>
                              <th className="px-3">Details</th>
                              <th className="px-3">Added</th>
                              <th className="px-3">Status</th>
                              <th className="px-3 action-col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tncs === null ? (
                              <tr>
                                <td colSpan={6} className="border-0">
                                  <Skeleton height={15} />
                                </td>
                              </tr>
                            ) : _.isEmpty(tncs) ? (
                              <tr>
                                <td colSpan={6} className="border-0">
                                  <div className="empty-data-block">No versions yet</div>
                                </td>
                              </tr>
                            ) : (
                              _.map(tncs, (tnc) => (
                                <tr key={tnc.id}>
                                  <td className="px-3">{tnc.version}</td>
                                  <td className="px-3">
                                    <a href={tnc.link} target="_blank" rel="noreferrer">
                                      {tnc.link}
                                    </a>
                                  </td>
                                  <td className="px-3">
                                    <div style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {tnc.details || '-'}
                                    </div>
                                  </td>
                                  <td className="px-3">{formatOfferDate(tnc.createdAt)}</td>
                                  <td className="px-3">
                                    <Badge pill bg={tnc.is_active ? 'success' : 'secondary'}>
                                      {tnc.is_active ? 'Active' : 'Old'}
                                    </Badge>
                                  </td>
                                  <td className="px-3">
                                    <span
                                      className="user-group-table-editIcon"
                                      title={tnc.is_active ? 'Edit' : 'View'}
                                      onClick={() => navigateTo(`/editTermsAndCondition/${tnc.id}`)}
                                    >
                                      {tnc.is_active ? <FiEdit2 /> : <FiEye />}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </LayoutContainer>
    </React.Fragment>
  );
};

export default TermsAndConditionList;
